import { getArea } from '@/apis/shopcart'
import { getAdtList, getAdtTmpl } from '@/apis/addition'
import useCache from './useCache'
import { getWarehouseCode, getWarehouseCodes, isD2C, useToken } from '@/store'

// 发货地区
export declare interface A {
  intAreaId: number
  label: string
  children?: A[]
}
export const area: Promise<A[]> = getArea({ type: 0 }).then((res) => res.data)

// 附加项
interface ADT {
  productAdditionList: any
  deliveryAdditionList: any
}

export const adtFn = (source?:number) => getAdtList({ productType: 1, source }).then((res) => {
  const { deliveryAdditionList, productAdditionList } = res.data
  // 调整附加险顺序
  const additionItem1 = productAdditionList.find((i:any) => i.additionCode === 74)
  const additionItem2 = productAdditionList.find((i:any) => i.additionCode === 75)
  const deliveryItem = deliveryAdditionList.find((i:any) => i.additionCode === 73)
  const addition = []
  if (additionItem1) {
    addition.push(additionItem1)
  }
  if (additionItem2) {
    addition.push(additionItem2)
  }
  const newArr = productAdditionList.filter((i:any) => ![74, 75].includes(i.additionCode))
  newArr.splice(productAdditionList.findIndex((i: any) => i.additionCode === 39) + 1, 0, ...addition)
  let newArr2 = deliveryAdditionList
  if (deliveryItem?.additionCode) {
    newArr2 = deliveryAdditionList.filter((i:any) => ![73].includes(i.additionCode))
    newArr2.splice(deliveryAdditionList.findIndex((i:any) => i.additionCode === 25) + 1, 0, deliveryItem)
  }
  return {
    deliveryAdditionList: deliveryAdditionList.find((i:any) => i.additionCode === 25) ? newArr2 : deliveryAdditionList,
    productAdditionList: productAdditionList.find((i:any) => i.additionCode === 39) ? newArr : productAdditionList
  }
})
// 普通商品附加项 发货附加项
const getAdt: (warehouseCode:string) => Promise<ADT> = useCache(
  (warehouseCode:string) => {
    return getAdtList({ productType: 1, warehouseCode }).then((res) => {
      console.log('getAdtList', res.data)
      const { deliveryAdditionList, productAdditionList } = res.data
      // 调整附加险顺序
      const additionItem1 = productAdditionList.find((i:any) => i.additionCode === 74)
      const additionItem2 = productAdditionList.find((i:any) => i.additionCode === 75)
      const deliveryItem = deliveryAdditionList.find((i:any) => i.additionCode === 73)
      const addition = []
      if (additionItem1) {
        addition.push(additionItem1)
      }
      if (additionItem2) {
        addition.push(additionItem2)
      }
      const newArr = productAdditionList.filter((i:any) => ![74, 75].includes(i.additionCode))
      newArr.splice(productAdditionList.findIndex((i: any) => i.additionCode === 39) + 1, 0, ...addition)
      let newArr2 = deliveryAdditionList
      if (deliveryItem?.additionCode) {
        newArr2 = deliveryAdditionList.filter((i:any) => ![73].includes(i.additionCode))
        newArr2.splice(deliveryAdditionList.findIndex((i:any) => i.additionCode === 25) + 1, 0, deliveryItem)
      }
      return {
        deliveryAdditionList: deliveryAdditionList.find((i:any) => i.additionCode === 25) ? newArr2 : deliveryAdditionList,
        productAdditionList: productAdditionList.find((i:any) => i.additionCode === 39) ? newArr : productAdditionList
      }
    })
  },
  (data: any) => data,
  1000 * 60 * 10
)
export const adt: (code?:string) => Promise<ADT> = async (warehouseCode = '') => {
  const codes = getWarehouseCodes() as string[]
  if (!codes.length)codes.push('')
  const data:any = {}
  await Promise.all(codes.map(code => getAdt(code).then(r => { data[code] = r })))
  console.log('data', data)
  // debugger
  return data[warehouseCode] ?? data[codes[0]]
}

// 组合商品附加项 组合发货附加项
export const gpAdt: (source?:number, warehouseCode?:string) => Promise<ADT> = (source, warehouseCode) => {
  return getAdtList({ productType: 2, source, warehouseCode }).then((res) => res.data)
}

// 后台已配置的附加项模板
export const adtTmpl: () => Promise<any> = useCache(
  () => getAdtTmpl().then((res) => res.data),
  (data: any) => data
)

// 物流公司
